/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * baseWs: WebSocket地址
 *
 */
const baseUrl = '';
const baseWs = process.env.NODE_ENV === 'development' ? 'ws://localhost:9765' : `ws://${window.location.hostname}:9765`;

export {
  baseUrl,
  baseWs,
};
